import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { Button } from '@flipster/react/design-system/button';
import { center } from '@flipster/styled-system/patterns';
import { getErrorMessage } from '@flipster/utils/error';
import segment from '@flipster/utils/segment';
import { EarnEvent } from '@flipster/utils/segment/events/earn';

import { userPoolBunja } from '../user-pool.state';
import { showAlert, showSnackbar } from '../utils';

const JoinButton = () => {
  const { eventStatusAtom, postUserPoolJoinMutationAtom, userPoolDataAtom } = useBunja(userPoolBunja);
  const status = useAtomValue(eventStatusAtom);
  const userPool = useAtomValue(userPoolDataAtom);

  const { mutateAsync: joinUserPool } = useAtomValue(postUserPoolJoinMutationAtom);

  const handleJoinUserPool = async () => {
    if (userPool?.eligible !== true) {
      showAlert({
        title: 'Pool not available',
        content:
          'We’re sorry, but you’re not eligible to join this earn pool based on the program rules for now.\n\nPlease stay tuned for our upcoming events, and contact support.flipster.io if you need further information.',
        confirmText: 'Got it',
      });
      return;
    }

    try {
      await joinUserPool();

      segment.track(EarnEvent.EarnTabJoinNewJoinerPool, {
        pool_status: status,
        estimate_full_reward_usdt: userPool?.totalReward ?? 0,
      });

      showSnackbar({
        message: 'You’re now in the new joiner pool',
      });

      segment.track(EarnEvent.EarnTabViewNewJoinerPoolToast, {
        toast_text: 'You’re now in the new joiner pool',
      });
    } catch (error) {
      showSnackbar({ message: getErrorMessage(error) });

      segment.track(EarnEvent.EarnTabViewNewJoinerPoolToast, {
        toast_text: getErrorMessage(error),
      });
    }
  };

  return (
    <div className={center({ py: 16, w: '100%' })}>
      <Button
        hierarchy='primary'
        size='large'
        label={userPool?.joined ? 'Joined' : 'Join now'}
        disabled={status === 'Closed' || userPool?.joined}
        onClick={handleJoinUserPool}
        css={{
          px: 32,
          w: {
            base: '100%',
            tablet: 300,
          },
        }}
      />
    </div>
  );
};

export default JoinButton;
